var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "choiceType", attrs: { id: "page_Container" } },
    [
      _c("div", { staticClass: "page" }, [
        _c(
          "div",
          { staticClass: "main-container", attrs: { id: "main-container" } },
          [
            _c(
              "div",
              { staticClass: "goodsList" },
              [
                _c(
                  "van-row",
                  _vm._l(_vm.dataRefund.refundOrderItemList, function(item) {
                    return _c(
                      "van-col",
                      {
                        key: item.id,
                        staticClass: "GoodInfo",
                        attrs: { span: "6" }
                      },
                      [
                        _c("img", { attrs: { src: item.productImg, alt: "" } }),
                        _vm._v(" "),
                        _c("p", [_vm._v("¥" + _vm._s(item.productPrice))])
                      ]
                    )
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "openUrl" },
              [
                _c(
                  "van-cell-group",
                  _vm._l(_vm.refundTypeData, function(item) {
                    return _c(
                      "van-cell",
                      {
                        key: item.id,
                        attrs: { title: "", value: "", "is-link": "" },
                        on: {
                          click: function($event) {
                            _vm.openRefund(item.type)
                          }
                        }
                      },
                      [
                        _c("template", { slot: "title" }, [
                          _c("img", { attrs: { src: item.refundUrl, alt: "" } })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "refundTypeStyle" }, [
                          _c("h5", [_vm._v(_vm._s(item.h5Text))]),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(item.pText))])
                        ])
                      ],
                      2
                    )
                  }),
                  1
                )
              ],
              1
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }